<app-network-status-info [status]="networkStatus$ | async" />

@let isAuthorized = isAuthorized$ | async;
<header>
    <router-outlet name="header" />
</header>

<main>
    @if (isAuthorized) {
        <router-outlet name="sidebar" />
    }
    <section>
        <router-outlet />
    </section>
</main>

<router-outlet name="footer"></router-outlet>

@if (isAuthorized) {
    <app-navbar-mobile />
}

